function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M-31,340.9c-6.4,3.3-13.5,5.7-19.9,8c-6.4-9.6-14.3-17.5-24.7-23.1c-9.6-5.6-21.5-8.8-32.6-8.8c-11.1,0-22.3,3.2-32.6,8.8 s-18.3,13.5-24.7,23.1c-7.2-2.4-14.3-4.8-21.5-8c6.4,4.8,12.4,10.2,17.2,14.9c-4.8,9.6-6.9,19.3-6.9,29.6c0,18.3,5.6,34.2,18.3,47 c11.9,13.5,27.1,20.7,45.4,21.5c1.6,7.2,3.2,15.1,4,23.1c0.8-7.2,2.4-15.1,4-23.1c17.5-1.6,32.6-8.8,45.4-21.5 c11.9-13.5,18.3-28.7,18.3-47c0-11.1-2.4-20.7-7.2-30.2C-42.9,350.4-37.4,345.6-31,340.9z M-137.7,333c8.8-4.8,17.5-7.2,27.9-7.2 s19.9,2.4,27.9,8c8.8,4.8,15.9,11.1,21.5,19.1c-4,1.6-6.4,1.8-8.8,2.4c-12.5,3.3-26.3,4-40.6,4s-27.9-1.6-40.6-4.8 c-3.2-0.8-6.4-1.6-8.8-2.4C-153.6,344.1-146.5,337.8-137.7,333z M-129.5,443.5c-13.5-4.4-21.5-12.9-24.8-16.5 c-10.3-11.1-15.9-24.7-15.9-40.6c-0.1-8.8,1.8-18.2,5-26.1c0,0,5.7,5.7,7.3,7.6c7.1,8.3,14.8,18.7,22.7,32 c10.4,17.4,16.4,33.6,19.9,46.2C-118.8,445.9-123.8,445.3-129.5,443.5z M-109,441c-6.6-25.3-27.8-61-48.9-82 c39.6,7.1,64.9,7.9,99.1-0.5C-85.7,379.4-99.3,412.7-109,441z M-65.1,427c-1.8,1.9-5,5.2-9.6,8.3c-10.9,7.6-21.9,10-29.1,10.8 c5.6-16.9,10.6-30.2,18.1-45.2c5.3-10.6,15.1-22.2,25.2-32.8c2.1-2.2,4.3-4.4,6.4-6.4c3.2,8,4.8,15.9,4.8,24.7 C-49.2,402.3-54.8,415.9-65.1,427z"
});

var SvgSwrpgDespair = function SvgSwrpgDespair(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "-207 299 196 196",
    style: {
      enableBackground: "new -207 299 196 196"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSwrpgDespair, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/swrpg-despair.c850fd5b.svg";
export { ForwardRef as ReactComponent };